<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content>
  <apx-chart
    [series]="$any(data.chart).series"
    [chart]="$any(data.chart).chart"
    [xaxis]="$any(data.chart).xaxis"
    [stroke]="$any(data.chart).stroke"
    [tooltip]="$any(data.chart).tooltip"
    [dataLabels]="$any(data.chart).dataLabels"
    [labels]="$any(data.chart).labels"
    [legend]="$any(data.chart).legend"
    [colors]="$any(data.chart).colors"
    [fill]="$any(data.chart).fill"
    [grid]="$any(data.chart).grid"
    [plotOptions]="$any(data.chart).plotOptions"
    [yaxis]="$any(data.chart).yaxis"
  ></apx-chart>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" type="button" (click)="close()">Cerrar</button>
</mat-dialog-actions>
